import { css } from '@emotion/css';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';

import { SIDE_NAVIGATION_WIDTH } from 'constants/navigation';

export const container = css`
  height: 100%;
  width: ${SIDE_NAVIGATION_WIDTH}px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  background-color: var(${DesignToken.NavbarBackground});
  padding: var(${SpacingToken.Spacing3}) var(${SpacingToken.Spacing1}) var(${SpacingToken.Spacing1})
    var(${SpacingToken.Spacing7});
  gap: var(${SpacingToken.Spacing5});
  color: var(${DesignToken.ContentBasicSecondary});
  overflow: hidden;
`;

export const headerRow = css`
  display: flex;
  align-items: center;
  padding: 0 var(${SpacingToken.Spacing3});
  height: 28px;
  flex-shrink: 0;
`;
export const title = css`
  color: var(${DesignToken.ContentLockedWhite});
`;

const scrollbar = css`
  scrollbar-width: thin;
  scrollbar-color: var(${DesignToken.ActionNeutralHover}) transparent;

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar {
    width: 4px;
  }
`;

export const navigationWrapper = (noGaps?: boolean): string => css`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${noGaps ? '0' : `var(${SpacingToken.Spacing5})`};
  overflow-y: auto;
  padding-bottom: var(${SpacingToken.Spacing5});
  padding-right: var(${SpacingToken.Spacing7});

  ${scrollbar}
`;

export const labelWithBadgeWrapper = css`
  display: flex;
  align-items: center;
`;

export const labelWithBadge = css`
  margin-right: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
